import { jsxs as f, Fragment as S, jsx as e } from "react/jsx-runtime";
import { Tooltip as b, Button as I, Menu as A, MenuList as x, MenuItem as C, ListItemIcon as E, Typography as L } from "@mui/material";
import k from "@mui/icons-material/Message";
import { useState as v } from "react";
import { O as w, m as l, l as B } from "../../../index-DNTqwtVt.js";
import { useAuth as N } from "../../../context/auth/index.js";
import { MessageType as c } from "../../../helpers/daymaptypes.js";
import { contacts as o } from "../../../types/contacts/index.js";
const q = ({ onNewMessage: m, personType: t }) => {
  const [p, u] = v(null), { settings: d } = w(), { IsImpersonating: r } = N(), y = (n) => {
    t === o.PersonTypeEnum.Student ? m(c.Peer) : u(n.currentTarget);
  }, M = (n) => {
    u(null), m(n);
  };
  if (!d)
    return null;
  const { ParentsAbsenceMessage: h, ParentsSchoolMessage: g, ParentsToStaff: i, StudentParentMessage: s, StudentsToStudents: T, StudentsToStaff: P } = d.Messaging;
  if (t === o.PersonTypeEnum.Parent && !h && !g && !i && !s || t === o.PersonTypeEnum.Student && !T && !P && !s)
    return null;
  const a = [];
  return t === o.PersonTypeEnum.Parent && (h && a.push({ type: c.AbsenceInbound, text: "Absence Notification", iconType: l.MessageAbsenceNotification }), g && a.push({ type: c.AdminInbound, text: "Message to the School", iconType: l.MessageSchoolMessage }), (i || s) && a.push({ type: c.Peer, text: `Message to ${i ? "a Teacher" : ""}${i && s ? " or" : ""}${s ? " your child/children" : ""}`, iconType: l.MessagePeer })), /* @__PURE__ */ f(S, { children: [
    /* @__PURE__ */ e(
      b,
      {
        title: "Cannot create new messages while impersonating",
        disableHoverListener: !r,
        disableFocusListener: !r,
        disableTouchListener: !r,
        children: /* @__PURE__ */ e("span", { children: /* @__PURE__ */ e(I, { variant: "contained", startIcon: /* @__PURE__ */ e(k, {}), disabled: r, onClick: y, children: "New Message" }) })
      }
    ),
    t === o.PersonTypeEnum.Parent && /* @__PURE__ */ e(A, { anchorEl: p, open: !!p, id: "messaging-menu", onClose: () => u(null), children: /* @__PURE__ */ e(x, { children: a.map((n) => /* @__PURE__ */ f(C, { onClick: () => M(n.type), children: [
      /* @__PURE__ */ e(E, { children: /* @__PURE__ */ e(B, { fontSize: "small", iconType: n.iconType }) }),
      /* @__PURE__ */ e(L, { variant: "body2", noWrap: !0, children: n.text })
    ] }, n.type)) }) })
  ] });
};
export {
  q as NewMessageButton
};
//# sourceMappingURL=NewMessageButton.js.map
